// texts.js

const texts = {
  LoginScreen: {
    user: {
      es: "Usuario:",
      en: "User:",
    },
    password: {
      es: "Contraseña:",
      en: "Password:",
    },
    login: {
      es: "Iniciar sesión",
      en: "login",
    },
  },
  ScanScreen: {
    text: {
      es: "Escaneando Código de barras",
      en: "Scanning Barcode",
    },
  },
  InfoScreen: {
    title: {
      es: "INSTRUCCIONES",
      en: "INSTRUCTIONS",
    },
    buttons: {
      timeAndWork: {
        es: "Tiempos y Estado",
        en: "Time and status",
      },
      incident: {
        es: "Incidencias",
        en: "Quality incidents",
      },
      qualityReception: {
        es: "Calidad / recepción",
        en: "Quality / reception",
      },
      workingTime: { es: "Tiempo de trabajo", en: "Working time" },
      multipleWorkinTime: {
        es: "Trabajo multiple",
        en: "Multiple work",
      },
      stoneDelivery: { es: "Entrega de piedras", en: "Delivery of stones" },
      fornitureDelivery: {
        es: "Entrega de fornituras",
        en: "Delivery of supply",
      },
      crimping: { es: "Engaste", en: "Set" },
      weighing: { es: "Pesaje", en: "Weighing" },
      Specifications: { es: "Detalles", en: "Specifications" },
      foundry: { es: "Fundición", en: "foundry" },
    },
  },
  FornitureDeliveryScreen: {
    user: {
      es: "Usuario",
      en: "User",
    },
    password: {
      es: "Contraseña",
      en: "Password",
    },
  },
  CrimpingScreen: {
    user: {
      es: "Usuario",
      en: "User",
    },
    password: {
      es: "Contraseña",
      en: "Password",
    },
  },
  ProblemQualityScreen: {
    user: {
      es: "Usuario",
      en: "User",
    },
    password: {
      es: "Contraseña",
      en: "Password",
    },
  },
  QualityReceptionScreen: {
    user: {
      es: "Usuario",
      en: "User",
    },
    password: {
      es: "Contraseña",
      en: "Password",
    },
  },
  StoneDeliveryScreen: {
    user: {
      es: "Usuario",
      en: "User",
    },
    password: {
      es: "Contraseña",
      en: "Password",
    },
  },
  TimeAndStatusScreen: {
    user: {
      es: "Usuario",
      en: "User",
    },
    password: {
      es: "Contraseña",
      en: "Password",
    },
  },
  TimeAndStatusScreen: {
    user: {
      es: "Usuario",
      en: "User",
    },
    password: {
      es: "Contraseña",
      en: "Password",
    },
  },
  MenuWork: {
    buttonStart: {
      es: "Iniciar trabajo",
      en: "Start work",
    },
    buttonPause: {
      es: "Pausar trabajo",
      en: "Pause work",
    },
    buttonStop: {
      es: "Finalizar trabajo",
      en: "Stop work",
    },
    tiempos: {
      es: "Tiempos",
      en: "Times",
    },
    operario: {
      es: "Operario",
      en: "Operator",
    },
    equipo: {
      es: "Equipo",
      en: "Team",
    },
    piedra: {
      es: "Piedra",
      en: "Stone",
    },
    inicio: {
      es: "Inicio",
      en: "Start",
    },
    fin: {
      es: "Fin",
      en: "End",
    },
    duracion: {
      es: "Duración",
      en: "Duration",
    },
    cantidad: {
      es: "Cantidad",
      en: "Quantity",
    },
    tipo: {
      es: "Tipo",
      en: "Type",
    },
  },
};

export default texts;
